/**
 * Auth-Store (Modul-State, kein React-Context) — Token-Provider + Re-Login/
 * Logout-Handler, registriert vom AuthProvider (Muster rmnc-personal
 * src/store/auth.ts, hier schlanker weil ohne zustand-Dependency).
 *
 * src/lib/api.ts nutzt getAccessToken() als Axios-Request-Interceptor —
 * dadurch bleibt der API-Client unabhängig davon, ob Dev- oder Logto-Modus
 * aktiv ist.
 */

export const AUTH_MODE: "dev" | "logto" | "authentik" =
  import.meta.env.VITE_AUTH_MODE === "dev"
    ? "dev"
    : import.meta.env.VITE_AUTH_MODE === "authentik"
      ? "authentik"
      : "logto"

type TokenProvider = () => Promise<string | null>

let _tokenProvider: TokenProvider | null = null

export function setTokenProvider(provider: TokenProvider | null): void {
  _tokenProvider = provider
}

export async function getAccessToken(): Promise<string | null> {
  if (!_tokenProvider) return null
  try {
    return await _tokenProvider()
  } catch {
    return null
  }
}

type AuthActionHandler = () => void | Promise<void>

let _reloginHandler: AuthActionHandler | null = null
let _logoutHandler: AuthActionHandler | null = null
let _reloginAttempted = false

export function setReloginHandler(handler: AuthActionHandler | null): void {
  _reloginHandler = handler
}

export function setLogoutHandler(handler: AuthActionHandler | null): void {
  _logoutHandler = handler
}

/** 401 vom Backend: genau EIN Re-Login-Versuch pro Seitenaufruf (Redirect-Schleife vermeiden). */
export function triggerRelogin(): void {
  if (AUTH_MODE === "dev") return
  if (_reloginAttempted || !_reloginHandler) return
  _reloginAttempted = true
  void _reloginHandler()
}

export async function performLogout(): Promise<void> {
  if (AUTH_MODE === "logto" && _logoutHandler) {
    await _logoutHandler()
  }
}
